<template>
  <section class="s-pt-1 s-pt-sm-1 s-pt-md-60 c-gutter-60">
    <div class="container mb-5">
      <div class="row flex-column-reverse flex-sm-row">
        <main class="col-lg-7 col-xl-8 woocommerce">
          <user-new></user-new>
        </main>
        <aside class="col-lg-5 col-xl-4 d-none d-sm-none d-md-block">
          <side-bar-expos></side-bar-expos>
          <side-bar-patrocinador></side-bar-patrocinador>
        </aside>
      </div>
    </div>
  </section>
</template>

<script>
import UserNew from "@/components/layouts/users/User-new.vue";
import SideBarExpos from "@/components/layouts/inicio/Sidebar-expos.vue";
import SideBarPatrocinador from "@/components/layouts/inicio/Side-patrocinador.vue";

export default {
  name: "Inicio",
  components: {
    UserNew,
    SideBarExpos,
    SideBarPatrocinador
  },
  data() {
    return {};
  }
};
</script>
